import { render, staticRenderFns } from "./marketSmsManageList.vue?vue&type=template&id=80d937a6&scoped=true"
import script from "./marketSmsManageList.vue?vue&type=script&lang=js"
export * from "./marketSmsManageList.vue?vue&type=script&lang=js"
import style0 from "./marketSmsManageList.vue?vue&type=style&index=0&id=80d937a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d937a6",
  null
  
)

export default component.exports